export const AdministrativeBoundariesEnum = Object.freeze({
    country: 'admin_level_1',
    province: 'admin_level_2',
    district: 'admin_level_3',
    subDistrict: 'admin_level_4'
})